import z from "zod/v4";

import { AssetType } from "../asset-type.types";
import { BaseRequestArgs } from "../base-reader";

export interface CandlesticksRequestArgs extends BaseRequestArgs {
  marketName: string;
  /**
   * Product the market name belongs to (default "perp"). Perp and spot
   * derive different addresses for the same name.
   */
  assetType?: AssetType;
  interval: CandlestickInterval;
  startTime: number;
  endTime: number;
  hideOutliers?: boolean;
}
export const CandlestickInterval = {
  OneMinute: "1m",
  FiveMinutes: "5m",
  FifteenMinutes: "15m",
  ThirtyMinutes: "30m",
  OneHour: "1h",
  TwoHours: "2h",
  FourHours: "4h",
  EightHours: "8h",
  TwelveHours: "12h",
  OneDay: "1d",
  ThreeDays: "3d",
  OneWeek: "1w",
  OneMonth: "1mo",
} as const;

export type CandlestickInterval = (typeof CandlestickInterval)[keyof typeof CandlestickInterval];

export const CandlestickSchema = z.object({
  /** time end */
  T: z.number(),
  /** close */
  c: z.number(),
  /** high */
  h: z.number(),
  /** internal */
  i: z.string(),
  /** low */
  l: z.number(),
  /** open */
  o: z.number(),
  /** time start */
  t: z.number(),
  /** volume */
  v: z.number(),
});
export const CandlesticksSchema = z.array(CandlestickSchema);
export const CandlestickWsMessageSchema = z.object({
  candle: CandlestickSchema,
});

export type Candlestick = z.infer<typeof CandlestickSchema>;
export type Candlesticks = z.infer<typeof CandlesticksSchema>;
export type CandlestickWsMessage = z.infer<typeof CandlestickWsMessageSchema>;
